export const cardsColorPallete = [
  '#FF9292',
  '#B4E8FF',
  '#BEFFBD',
  '#8ABADE',
  '#88BBAA',
  '#CDB3D5',
  '#F8B2BC',
  '#FBDEDE',
  '#F9F08D',
];
